<huk-footer
  [additionallinks]="additionalLinks"
  nocontactlink
  size="small">
</huk-footer>
